import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import { httpss } from '../utils/host';

export default function UserAPI() {
  const [usersDashboard, setUsersDashboad] = useState([]);
  const [callback, setCallback] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const accessToken = sessionStorage.getItem('accessToken');

  const fetchUsers = async () => {
    try {
      const response = await axios.post(`${httpss}/apis_v1/user/dashboard`, 
        // { accessToken }
      );
      setUsersDashboad(response.data);
      setRefresh(false);
      setCallback(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      // sessionStorage.clear();
      // window.location.reload();
      // setRefresh(true);
    }
  };

  useEffect(() => {
    if (accessToken) {
      fetchUsers();
    }
  }, [accessToken, callback]); // Chỉ gọi lại khi accessToken hoặc callback thay đổi

  return {
    usersDashboard: [usersDashboard, setUsersDashboad],
    refresh: [refresh, setRefresh],
    callback: [callback, setCallback]
  };
}
